import {OrderPlacerForm} from '../../../../fields/orderPlacer/types'
import {parsePhoneNumber} from '../../../../utils/phoneNumberUtils'
import {CreateFormInput} from '../types'

export const buildOrderPlacerForm = ({order}: CreateFormInput<unknown>): OrderPlacerForm => {
  return {
    orderPlacer: order.contactInformation
      ? {
          name: order.contactInformation.orderPlacerName,
          phoneNumber: order.contactInformation.orderPlacerPhoneNumber
            ? parsePhoneNumber(
                order.contactInformation.orderPlacerPhoneNumber,
                order.orgUnitCountryId
              )
            : undefined
        }
      : undefined
  }
}
